import { useCurrentTracking } from './use-current-tracking';
export function useTrackingUrl() {
  var _useCurrentTracking;

  return (_useCurrentTracking = useCurrentTracking()) === null || _useCurrentTracking === void 0 ? void 0 : _useCurrentTracking.trackingUrl;
}